/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function(){
   $("#section-collection-list").prepend('<h2 class="SectionHeader__SubHeading Heading u-h6">Our Scents</h2>');
  
  function Search(){
  $("#Search .Search__Close").click(function(){
    $(".PageOverlay").click();
  });
  }
  Search();
  
  $(".search-button").click(function(){
  Search();
  });
    
  $(".mobile-search-button").click(function(){
  	$(".Drawer__Close").click();  	
  });
  
});


window.addEventListener('load', function() {
    document.querySelector('.yotpo-reviews-main-widget').style.height = '100%';
});


